/**
 * Styles.
 */
import './style.scss';

/**
 * External Dependencies
 */
import React, { Component } from 'react';

/**
 * Internal Dependencies
 */
import AsyncComponent from '../../components/async-component';
import PageWrap from '../../components/page-wrap';
import PageTitle from '../../components/page-title';
import PageContent from '../../components/page-content';
import { Row, Col } from 'reactstrap';

/**
 * Component
 */
class AdminUserDetail extends Component {
  render() {
    return (
      <PageWrap>
        <PageTitle
          breadcrumbs={{
            '/': 'Admin',
            '/admin/users': 'Pengguna',
          }}
        >
          <Row className="mb-0">
            <Col lg="6">
              <h1>Detail Pengguna / User</h1>
            </Col>
          </Row>
        </PageTitle>
        <PageContent>
          <AsyncComponent component={() => import('./content')} />
        </PageContent>
      </PageWrap>
    );
  }
}

export default AdminUserDetail;
